import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./FreeEvent.css";
import Header from "../../components/Header/Header";
import BottomNav from "../../components/BottomNav/BottomNav";
import Announcement from "../../common/Announcement";
import NoData from "../../common/NoData";

export default function FreeEvent({ freeEvents = [], globalData }) {
  const navigate = useNavigate();

  const getProviderName = (item) => {
    return (
      item?.provider ||
      item?.platform ||
      item?.system ||
      item?.provider_name ||
      item?.category ||
      "All"
    );
  };

  const providerTabs = useMemo(() => {
    const uniqueProviders = [
      ...new Set(
        freeEvents
          .map((item) => getProviderName(item))
          .filter(Boolean)
      ),
    ];

    return ["All", ...uniqueProviders];
  }, [freeEvents]);

  const [activeTab, setActiveTab] = useState("All");

  useEffect(() => {
    if (!providerTabs.includes(activeTab)) {
      setActiveTab("All");
    }
  }, [providerTabs, activeTab]);

  const filteredEvents = useMemo(() => {
    if (activeTab === "All") return freeEvents;

    return freeEvents.filter(
      (item) => getProviderName(item).toLowerCase() === activeTab.toLowerCase()
    );
  }, [activeTab, freeEvents]);

  const handleCardClick = (item) => {
    navigate("/free-event-detail", {
      state: { freeEvent: item },
    });
  };

  return (
    <div className="free-event-app">
      <Header />

      <div className="free-event-page-shell">
        <div className="free-event-top-banner">
         
        </div>

        <div className="free-event-announcement-wrap">
          <Announcement globalData={globalData} />
        </div>

        <div className="free-event-heading-row">
          <span className="free-event-heading-line" />
          <h2>Slots</h2>
          <span className="free-event-heading-line" />
        </div>

        <div className="free-event-provider-bar">
          <div className="free-event-provider-scroll">
            {providerTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                className={`free-event-provider-tab ${
                  activeTab === tab ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="free-event-grid">
          {filteredEvents.length > 0 ? (
            filteredEvents.map((item) => (
              <button
                key={item?.id || item?.name}
                type="button"
                className="free-event-card"
                onClick={() => handleCardClick(item)}
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}/storage/${item?.thumbnail}`}
                  alt={item?.name || "Free Event"}
                  className="free-event-card-img"
                  loading="lazy"
                />

                <div className="free-event-card-overlay" />

                <div className="free-event-card-title">
                  {item?.name || item?.title || "FREE EVENT"}
                </div>
              </button>
            ))
          ) : (
            <NoData />
          )}
        </div>
      </div>

      <BottomNav />
    </div>
  );
}